import { Risk } from '@views/risk'
import { useQuery } from '@tanstack/react-query'
import { getRisk } from '@api/risk'
import { useParams } from 'react-router'
import { mutationKeys } from '@definitions'
import { LayoutContainer } from 'common-components'

import { riskMapperApi } from '@/mappers'
import { RiskProvider } from '@/context'

const RiskPage = () => {
  const { idRisk } = useParams<{
    idRisk: string
  }>()

  const {
    data: risk,
    isLoading,
    isRefetching,
  } = useQuery({
    queryKey: mutationKeys.risks({ id: idRisk }),
    queryFn: () => getRisk(idRisk),
    enabled: !!idRisk,
    select: riskMapperApi,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
  })

  return (
    <LayoutContainer style={{ minHeight: '100vh' }}>
      <RiskProvider>
        {!!risk && <Risk risk={risk} isLoading={isLoading || isRefetching} />}
      </RiskProvider>
    </LayoutContainer>
  )
}

export default RiskPage
